import React from "react"
import { PreviewAvatar } from "~widgets/avatar"
import { observer } from "mobx-react-lite"
import { ProfileProps } from "./types"
import { BetweenFlex, ColumnFlex, Text } from "~components/El"
import { OnlineStatus } from "~widgets/online-status"

const Profile: React.FC<ProfileProps> = ({ ...rest }) => {
  return (
    <ColumnFlex height="auto" width="100%" padding="10px">
      <BetweenFlex height="auto" width="100%" gap="15px">
        <PreviewAvatar
          size={40}
          avatar={rest.avatar}
          name={rest.name}
        />
        <ColumnFlex height="auto" width="auto" flex={1} gap='4px'>
          <Text color={"text"} fontSize={"20px"} fontWeight="600">
            {rest?.contactName || rest?.name}
          </Text>
          <OnlineStatus last_seen={rest.last_seen} online={rest.online} />
          <Text color={"secondaryText"} fontSize={"12px"}>
            {rest?.desc}
          </Text>
        </ColumnFlex>
      </BetweenFlex>
    </ColumnFlex>
  )
}

export default observer(Profile)
